/** 首頁跑馬燈（後續改接 CMS） */
export const HOME_MARQUEE_ITEMS = [
  '12026-06-01 10:59:51 中大獎中大獎中大獎中',
  '歡迎使用 Formosa 交易平台',
  '支援 BTC、USDT、ETH 等多種資產',
];

/** 公告跑馬燈 */
export const HOME_ANNOUNCEMENT_ITEMS = [
  '中大獎中大獎中大獎中大獎中大獎中大獎中大獎中大獎',
];

/** 國際新聞（後續改接 CMS） */
export const HOME_NEWS_ITEMS = [
  {
    id: 1,
    title: '外媒預測 Pi 代幣於 2026 年下半年將持續處於弱勢區間',
    time: '2026-06-13 07:10:08',
  },
  {
    id: 2,
    title: '比特幣突破關鍵阻力位，市場情緒轉暖',
    time: '2026-06-12 18:22:15',
  },
  {
    id: 3,
    title: '以太坊 Layer2 生態持續擴張',
    time: '2026-06-11 09:45:33',
  },
];

/** 關於我們 */
export const HOME_ABOUT_TEXT =
  'Formosa 致力於提供安全、穩定、高效的數位資產交易服務，支援多種主流幣種與合約產品，為全球用戶打造專業的交易體驗。';

/** 快捷入口八宮格 */
export const HOME_QUICK_ACTIONS = [
  { key: 'deposit', label: '入款', icon: 'deposit', auth: true, path: '/deposit' },
  { key: 'withdraw', label: '取款', icon: 'withdraw', auth: true, path: '/withdraw' },
  { key: 'support', label: '客服中心', icon: 'support', auth: false, path: '/support' },
  { key: 'download', label: '下載APP', icon: 'download', auth: false, path: '' },
  { key: 'timed', label: '限時交易', icon: 'timed', auth: false, path: '/trade/timed' },
  { key: 'delivery', label: '交割合約', icon: 'delivery', auth: false, path: '/trade/futures' },
  { key: 'perpetual', label: '永續合約', icon: 'perpetual', auth: false, path: '/trade/perpetual' },
  { key: 'invite', label: '好友邀請', icon: 'invite', auth: true, path: '/invite' },
];
